import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { id: "MainDashboard" }
const _hoisted_3 = {
  key: 0,
  class: "bottomSpaceDouble"
}
const _hoisted_4 = {
  class: "myApps",
  "data-testid": "myApps"
}
const _hoisted_5 = { class: "sectionHeader" }
const _hoisted_6 = {
  key: 0,
  class: "appsRow"
}
const _hoisted_7 = {
  key: 1,
  class: "moreApps",
  "data-testid": "moreApps"
}
const _hoisted_8 = { class: "sectionHeader" }
const _hoisted_9 = {
  key: 0,
  class: "moreAppsRow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CwePageHeader = _resolveComponent("CwePageHeader")!
  const _component_AppListItem = _resolveComponent("AppListItem")!
  const _component_MoreAppListItem = _resolveComponent("MoreAppListItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CwePageHeader, { authenticationRequired: false }),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.usersApps.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('no_apps_enabled_for_your_account')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('my_zbedge_apps')), 1),
        (_ctx.usersApps.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersApps, (app) => {
                return (_openBlock(), _createBlock(_component_AppListItem, {
                  key: app.name,
                  app: app
                }, null, 8, ["app"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.moreApps.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.$t('more_apps_to_consider')), 1),
            (_ctx.moreApps.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moreApps, (app) => {
                    return (_openBlock(), _createBlock(_component_MoreAppListItem, {
                      key: app.name,
                      app: app
                    }, null, 8, ["app"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}